import { cn } from "@edusogno/lib/utils.js";
import ReferCrownIcon from "../icons/refer-a-friend/ReferCrownIcon";
import ReferBigLockIcon from "../icons/refer-a-friend/ReferBigLockIcon";
import ReferBigLockWithCrownIcon from "../icons/refer-a-friend/ReferBigLockWithCrownIcon";
import ReferAltOneIcon from "../icons/refer-a-friend/ReferAltOneIcon";
import ReferAltTwoIcon from "../icons/refer-a-friend/ReferAltTwoIcon";
import ReferLockIcon from "../icons/refer-a-friend/ReferLockIcon";
import { useTranslation } from "react-i18next";

interface ProgressProps {
  numberOfFriends: number;
}

const Progress: React.FC<ProgressProps> = ({ numberOfFriends }) => {
  const { t } = useTranslation();

  const labels = [
    {
      icon: ReferLockIcon,
      // label: "1 friend",

      label: t("refer_a_friend.unlock.labels.alt_text_1"),
    },
    {
      icon: ReferLockIcon,
      // label: "4 friends",

      label: t("refer_a_friend.unlock.labels.alt_text_2"),
    },
    {
      icon: ReferCrownIcon,
      // label: "8 friends",

      label: t("refer_a_friend.unlock.labels.alt_text_3"),
    },
  ];
  const largeLabels = [
    {
      icon: ReferBigLockIcon,
      // label: "1 friend",

      label: t("refer_a_friend.unlock.labels.alt_text_1"),
      value: 1,
      altIcon: ReferAltOneIcon,

      altText: t("refer_a_friend.unlock.large_labels.alt_text_1"),
      // altText: "4 1:1 lessons valued at €60 each",
    },
    {
      icon: ReferBigLockIcon,
      // label: "3 friends",

      label: t("refer_a_friend.unlock.labels.alt_text_2"),
      value: 4,
      altIcon: ReferAltTwoIcon,

      altText: t("refer_a_friend.unlock.large_labels.alt_text_2"),
      // altText: "€200 discount on your next course",
    },
    {
      icon: ReferBigLockWithCrownIcon,
      // label: "8 friends",

      label: t("refer_a_friend.unlock.labels.alt_text_3"),
      value: 8,
      altIcon: ReferAltTwoIcon,

      altText: t("refer_a_friend.unlock.large_labels.alt_text_3"),
      // altText: "Branded T-shirt and hoodie",
    },
  ];
  return (
    <div className={"flex flex-col w-full gap-2"}>
      <div className={"flex flex-col w-full gap-[10px]"}>
        <ul className={"grid grid-cols-[repeat(3,calc(100%_/_3))]"}>
          {labels.map((r, idx) => {
            const Icon = r?.icon;
            return (
              <li
                key={"label-" + idx}
                className={"flex flex-col items-center last:w-fit last:ml-auto"}
              >
                <Icon />
                <p
                  className={
                    "text-[--secondary]  text-[10px] font-normal leading-[120%]"
                  }
                >
                  {r?.label}
                </p>
              </li>
            );
          })}
        </ul>
        <div className={"grid grid-cols-[repeat(8,calc(100%_/_8))]"}>
          {Array.from({ length: 8 }).map((_, idx) => (
            <div
              key={"friend-" + idx}
              className={cn(" rounded-[5px] h-[9px] w-full", {
                "bg-[#D5D3DB]": idx > numberOfFriends - 1,
                "bg-[--primary]": idx <= numberOfFriends - 1,
              })}
            />
          ))}
        </div>
      </div>
      <div className={"flex flex-col w-full gap-4"}>
        <p className={"text-[10px] font-normal leading-[120%]"}>
          {/* Friends who signed up:&nbsp; */}
          {t("refer_a_friend.progress.info")}&nbsp;
          <b
            className={cn("font-semibold ", {
              "text-[#E31837]": numberOfFriends === 0,
              "text-[--primary]": numberOfFriends > 0,
            })}
          >
            {numberOfFriends}
          </b>
        </p>
        <ul
          className={
            " lg:bg-[#E7DEFF] bg-[transparent] flex  gap-4 lg:gap-0 lg:flex-row flex-col items-center justify-evenly rounded-md"
          }
        >
          {largeLabels.map((r, idx) => {
            const isAlt = r?.value <= numberOfFriends;
            const Icon = isAlt ? r?.altIcon : r?.icon;
            return (
              <li
                key={"large-label" + idx}
                className={
                  "flex bg-[#E7DEFF66] lg:bg-transparent flex-row justify-start w-full lg:justify-center items-center px-[10px]"
                }
              >
                <i className="shrink-0">
                  <Icon />
                </i>
                {isAlt ? (
                  <div
                    className={"flex flex-col max-w-[200px] lg:max-w-[180px]"}
                  >
                    <h5
                      className={
                        "text-[--secondary] text-[10px] font-semibold leading-[120%]"
                      }
                    >
                      {t("refer_a_friend.unlock.text")}
                    </h5>
                    <p
                      className={
                        "text-sm text-[--primary] font-semibold leading-[100%]"
                      }
                    >
                      {r?.altText}
                    </p>
                  </div>
                ) : (
                  <p
                    className={
                      "text-[--primary]  text-[14px] font-semibold leading-[120%]"
                    }
                  >
                    {r?.label}
                  </p>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};
export default Progress;
